import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Section from './pages/Section';
import JewelDetail from './pages/JewelDetail';
import Cart from './pages/Cart';
import EnquiryConfirmed from './pages/EnquiryConfirmed';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminEnquiries from './pages/AdminEnquiries';
import AdminBilling from './pages/AdminBilling';
import './App.css';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from './utils/analytics';

function App() {
  function RouteChangeTracker() {
    const location = useLocation();
    useEffect(() => {
      trackPageView(location.pathname + location.search);
    }, [location]);
    return null;
  }

  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Navbar />
          <RouteChangeTracker />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/section/:material" element={<Section />} />
              <Route path="/jewel/:id" element={<JewelDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/enquiry-confirmed/:id" element={<EnquiryConfirmed />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/enquiries" element={<AdminEnquiries />} />
              <Route path="/admin/billing" element={<AdminBilling />} />
            </Routes>
          </main>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
